import { Link } from 'react-router';
import { Brand } from '../components/Header';

const CONTACT = 'jbchchi@jbchusa.org';

/** Public privacy policy (linked from the Google sign-in consent screen); readable without signing in. */
export function PrivacyPage() {
  return (
    <>
      <header className="top">
        <div className="top-row studio-row solo">
          <div className="top-left">
            <Brand />
          </div>
        </div>
      </header>
      <main className="wrap">
        <article className="panel privacy">
          <h2>Privacy policy</h2>
          <p className="help">JBCH USA Photos · photos.jbchusa.org · Last updated October 13, 2026</p>

          <p>
            JBCH USA Photos is the private photo archive of JBCH USA. Only members approved by the church can see photos.
            This page explains what we keep about you and why.
          </p>

          <h3>What we collect</h3>
          <ul>
            <li>
              <b>Your account:</b> your name and email address. If you sign in with Google, we receive only your name and
              email from Google, nothing else from your Google account.
            </li>
            <li>
              <b>Your profile:</b> what you enter when you request access or edit My profile: phone number (optional),
              region, church, fellowship group and service groups.
            </li>
            <li>
              <b>Photos:</b> photos uploaded by the media team, with the information the camera stored in them (date,
              camera model and, if the camera recorded it, the location).
            </li>
            <li>
              <b>Activity:</b> sign-ins, downloads, share links and changes made in Studio and Admin, so mistakes can be
              undone and access can be reviewed.
            </li>
          </ul>

          <h3>How it is used</h3>
          <ul>
            <li>To decide who may see which photos, and to show you the photos you are allowed to see.</li>
            <li>To let church admins approve, manage and contact members of the app.</li>
            <li>
              Your account and profile are shared with other JBCH USA church apps, so one account works across them.
            </li>
          </ul>
          <p>
            We never sell your information, show ads, or share it with anyone outside JBCH USA. Photos are never public:
            every photo link is private and expires after about an hour.
          </p>

          <h3>Where it is kept</h3>
          <p>
            Everything is stored in the church’s Amazon Web Services account in the United States, encrypted. The app
            keeps only what your browser needs to stay signed in; it uses no tracking or advertising cookies.
          </p>

          <h3>How long</h3>
          <ul>
            <li>Your account and profile: until you ask us to delete them.</li>
            <li>Photos: kept as the church’s archive. Deleted photos stay in Trash for 30 days, then are removed.</li>
            <li>Activity records: up to 2 years.</li>
          </ul>

          <h3>Your choices</h3>
          <ul>
            <li>You can edit your profile at any time in My profile.</li>
            <li>
              If you appear in a photo you would like removed, open it and choose <b>Request removal</b>; the photo is
              hidden at once while the media team reviews it.
            </li>
            <li>
              To see, correct or delete your information, or for any question, email{' '}
              <a href={`mailto:${CONTACT}`}>{CONTACT}</a>.
            </li>
          </ul>

          <p>
            <Link to="/">Back to photos</Link>
          </p>
        </article>
      </main>
    </>
  );
}
